/**
 * Set attribute
 * @param {Array<HTMLElement>} targets
 * @param {String} name
 * @param {String} values
 */
const attributeSet = (targets, name, values = "") => {
  for (const target of targets) {
    /** No values defined. Set whole attribute */
    target.setAttribute(name, values);
  }
};

export default attributeSet;
